/**
 * Check if a path is a Cloudflare internal path that should not be used as a redirect target.
 * Cloudflare Zero Trust uses /cdn-cgi/* paths for authentication flows.
 *
 * @example
 * isCloudflareInternalPath('/cdn-cgi/access/login') // true
 * isCloudflareInternalPath('/dashboard') // false
 */
export function isCloudflareInternalPath(path: string): boolean {
  return path.startsWith('/cdn-cgi/');
}
